import React from 'react';
import { motion } from 'framer-motion';

const WorkPlace = () => {

    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-[#F1F1F1] font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    variants={fadeUpVariant}
                    className="relative"
                >
                    <div className="flex lg:flex-row flex-col-reverse group cursor-pointer overflow-hidden border border-[#E4E8F5] transition-shadow duration-300 hover:shadow-md bg-[#FFFFFF] rounded-sm">

                        <div className="max-w-[774px] w-full relative flex flex-col justify-center h-auto lg:py-[40px] py-[24px] lg:px-[70px] px-[20px] sm:px-[30px]">

                            <div>
                                <h6 className="font-[600] font-sora text-[20px] lg:text-[30px] text-[#01386A] mb-[12px] sm:mb-[20px]">
                                    A workplace built around you
                                </h6>
                            </div>

                            <div>
                                <p className="font-graphik max-w-[616px] w-full font-[500] text-[14px] lg:text-[16px] text-[#49577A] leading-[1.6]">
                                    At Mobikode, we believe great work starts with great people. That’s why we foster a supportive, connected culture where well-being is valued, flexibility is encouraged, and everyone has the opportunity to grow, succeed, and enjoy a healthy balance between work and life.
                                </p>
                            </div>

                            <div
                                className="absolute bottom-0 left-0 h-[4px]"
                                style={{ backgroundColor: "#01386A", width: '100%' }}
                            />
                            <div
                                className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#F97316] transition-all duration-500 ease-out group-hover:w-full z-10"
                            />
                        </div>
                        <div className="max-w-full lg:max-w-[506px] w-full lg:ml-auto overflow-hidden h-[240px] sm:h-[300px] lg:h-auto shrink-0">
                            <img
                                src="/assets/work/img1.png"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                alt="Learning and development"
                            />
                        </div>

                    </div>
                </motion.div>

            </div>
        </section>
    );
};

export default WorkPlace;